import { CalendarDotsIcon } from '@phosphor-icons/react';
import { DatePicker as AntdDatePicker } from 'antd';
import type { ComponentProps } from 'react';

import styles from './date-picker.module.scss';

export type DatePickerProps = Omit<ComponentProps<typeof AntdDatePicker>, 'suffixIcon'>;

export function DatePicker({
  className,
  classNames,
  format,
  placeholder,
  ...rest
}: DatePickerProps) {
  return (
    <AntdDatePicker
      {...rest}
      format={format ?? 'MM/DD/YYYY'}
      placeholder={placeholder ?? 'mm/dd/yyyy'}
      suffixIcon={<CalendarDotsIcon size={14} aria-hidden />}
      className={[styles.picker, className].filter(Boolean).join(' ')}
      classNames={{
        ...classNames,
        popup: {
          root: [styles.popup, (classNames as { popup?: { root?: string } })?.popup?.root]
            .filter(Boolean)
            .join(' '),
        },
      }}
    />
  );
}
